import { FormFieldComponentProps } from "../components/new_form/form_fields/FormFieldComponent";
import { getSession } from "../helper";
import { LIST_ORGANIZATIONS } from "./routes";

export function getPersonFormFields(): FormFieldComponentProps[] {
  return [
    {
      type: "text",
      required: true,
      placeholder: "Person Name",
      key: "name",
      label: "Name",
    },
    {
      type: "multiple_selection_query_dropdown",
      key: "organizationIds",
      label: "Organizations",
      required: false,
      apiCall: {
        documentNode: LIST_ORGANIZATIONS,
        key: "listOrganizations",
      },
      apiVariables: {
        session: getSession(),
      },
      itemName: "Organization",
    },
  ];
}
